import $ from 'jquery';
import { callApi } from './util';
import ratingTmpl from './hbs/rating.hbs';
const $ratingTmpl = $.templates(ratingTmpl);
let dataArr, chartData = C.TVP.data.ratings;

// const dataUrl = '/qsearch?w=tv&m=ratings&viewtype=json&q=&mk=Wg5NJcuFoogAAGuFJRUAAAAf&uk=V3y5Yt7nKNoAAUk18EcAAACr';

const onAirSchedule = C.TVP.data.onAirSchedule || {};
const channelId = Number(onAirSchedule.channelId) || '';
let realtimeData = {};

function dateNow() {
  const date = new Date();
  Date.prototype.now = function () {
    const month = this.getMonth() + 1;
    const day = this.getDate();
    const hour = this.getHours();
    const minutes = this.getMinutes();
    return [
      this.getFullYear(), (month > 9 ? '' : '0') + month, (day > 9 ? '' : '0') + day, (hour > 9 ? '' : '0') + hour, (minutes > 9 ? '' : '0') + minutes].join('');
  };
  return date.now();
}

function getRatingsData() {
  const $ratingDeferred = new $.Deferred();
  const params = { cnucc: '', w: 'tv', m: 'ratings', viewtype: 'json' };
  const dataUrl = SF.getQsUrl(params, 1);

  callApi(dataUrl).done((response) => {
    $ratingDeferred.resolve(response);
  });
  return $ratingDeferred;
}

function ratings(ctx, response) {
  const rankData = response.RESULT.TV_REALTIME_RATINGS.data.items;
  rankData.forEach(item => {
    item.channelId === channelId ? realtimeData.thisRating = item.ratings : '';
  });

  if (onAirSchedule.broadcastStartTime <= dateNow() && dateNow() < onAirSchedule.broadcastEndTime && onAirSchedule.rebroadcastYn === 'N' && realtimeData.thisRating) {
    const $ctx = ctx;
    const $wrapper = $ctx.find('.realtimeRating');

    $wrapper.removeClass('hide');
    realtimeData.ratingRank = rankData.slice(0, 3);
    realtimeRating(onAirSchedule, realtimeData, onAirSchedule);

    const htmlOutput = $ratingTmpl.render(realtimeData, {
      txtPercent: function (txt, limit) {
        return Number(txt).toFixed(limit);
      },
      rankWidth: function (rating) {
        return Math.ceil(rating / realtimeData.ratingRank[0].ratings * 100) + '%';
      },
      graphType: function () {
        return $wrapper.parents('.tab_cont').attr('id');

      },
      startTime: function () {
        return $.format.dateformat(onAirSchedule.broadcastDate, 'MM.dd (e)');
      },
      txtPosition: function (num) {
        if (num >= 25 && num <= 85) {
          return (num - 25).toFixed(2);
        } else if (num > 85) {
          return 60;
        }
      }, encodeUri: function (txt) {
        return encodeURIComponent(txt);
      },
      docId:function(){
        return C.TVP.data.docId;
      }
    });
    $wrapper.html(htmlOutput);
  }
}


function replaceColon(str) {
  return str.replace(/\B(?=(\d{2})+(?!\d))/g, ":");
}
function toTimeObject(time) {
  const year = time.substr(0, 4);
  const month = time.substr(4, 2) - 1;
  const day = time.substr(6, 2);
  const hour = time.substr(8, 2);
  const min = time.substr(10, 2);

  return new Date(year, month, day, hour, min);
}


function realtimeRating(data, data2, schedule) {
  const startTime = toTimeObject(data.broadcastStartTime).getTime();
  const endTime = toTimeObject(data.broadcastEndTime).getTime();
  const nowTime = new Date().getTime();
  let duration = (endTime - startTime) / 60000;
  let passTime = (nowTime - startTime) / 60000;

  data2.startTime = replaceColon(schedule.broadcastStartTime.slice(-4));
  data2.endTime = replaceColon(schedule.broadcastEndTime.slice(-4));
  data2.channelName = schedule.channelName;
  data2.sequence = schedule.episodeSequence;
  data2.width = (passTime / duration * 100);
}

function drawRatingChart(cont, graph1) {
  const $btnPrev = cont.find('.btn_prev');
  const $btnNext = cont.find('.btn_next');
  let chart, len = dataArr.length - 1, idx = 0;
  if (!chartData) {
    return;
  }

  SF.loadModule('AmCharts', function (status, info) {
    if (status !== "success") return;
    chart = new AmCharts.makeChart(graph1, {
      type: 'serial',
      dataProvider: chartData,
      categoryField: 'label',
      marginRight: 0,
      marginLeft: 0,
      categoryAxis: {
        gridAlpha: 0,
        axisThickness: 0,
        axisAlpha: 0,
        color: '#777'
      },
      valueAxes: [{
        axisAlpha: 0,
        gridAlpha: 0,
        gridColor: '#f0f1f3',
        axisThickness: 0,
        gridThickness: 1,
        ignoreAxisWidth: true,
        axisColor: '#777777',
        includeGuidesInMinMax: false,
      }],
      graphs: [{
        valueField: 'rating',
        bullet: 'round',
        bulletSize: 5,
        bulletBorderAlpha: 1,
        bulletBorderColor: "#f73e47",
        bulletBorderThickness: 1,
        bulletColor: '#ffffff',
        lineColor: '#ff0000',
        labelText: '[[rating]]%',
        showBalloon: false,
      }]
    });
    $btnPrev.on('click', function () {
      if (idx < len) {
        idx += 1;
        chart.dataProvider = dataArr[idx];
        chart.validateData();
        $(this).addClass('on');
        $btnNext.addClass('on');
      } else {
        $(this).removeClass('on');
      }
    });

    $btnNext.on('click', function () {
      if (idx > 0 && idx <= len) {
        idx -= 1;
        chart.dataProvider = dataArr[idx];
        chart.validateData();
        $(this).addClass('on');
        $btnPrev.addClass('on');
      } else {
        $(this).removeClass('on');
      }
    });
  });
}



function graphDataInit(ctx) {
  C.TVP.data.ratings.reverse();
  chartData.forEach((item, index) => {
    const date = item.date;
    const formattedDate = [date.substr(0,4), date.substr(4,2), date.substr(6,2)].map((item, index) => {
      try {
        return Number(item);
      } catch (e) {
        return item;
      }
    }).join('.');

    chartData[index]['label'] = item.sequence + '<br>' + formattedDate;
  });
  dataArr = chunk(chartData, 5);
  dataArr.forEach(function (item, index) {
    item.reverse();
  });
  chartData = dataArr[0];
}

function chunk(arg, size) {
  var arr = [];
  var arrLength = arg.length;
  var count = arrLength / size;
  for (var i = 0; i < count; i++) {
    arr.push(arg.splice(0, size));
  }
  return arr;
}

graphDataInit();



export { ratings, drawRatingChart, getRatingsData };


/** WEBPACK FOOTER **
 ** ./src/TVP/rating.js
 **/